import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../../app-config';
import { tap } from 'rxjs/operators';
import { TokenStorageService } from '../auth/token-storage.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  observe: 'response' as 'body'
};

@Injectable({
  providedIn: 'root'
})
export class ProfesionService {

  constructor(private http: HttpClient,
              private tokenStorage: TokenStorageService,
              private appConfig:AppConfig
              ) {
                this.API_URL = appConfig.api_url;
              }
  API_URL = "";

  getAll(page, pageSize): Observable<any> {
    return this.http.get(this.API_URL + 'profesion/all?pagina='+page+'&cantidad='+pageSize, httpOptions).pipe(tap(tipo => {
      return tipo;
    }));
  }

  getList(): Observable<any> {
    return this.http.get(this.API_URL + 'profesion/list', httpOptions).pipe(tap(tipo => {
      return tipo;
    }));
  }

  count(): Observable<any> {
    return this.http.get(this.API_URL + 'profesion/count', httpOptions);
  }

  register(user): Observable<any> {
    return this.http.post(this.API_URL + 'profesion/add', user, httpOptions);
  }

  delete(id): Observable<any> {
    return this.http.delete(this.API_URL + 'profesion/' + id, httpOptions);
  }

  edit(id, user): Observable<any> {
    return this.http.put(this.API_URL + 'profesion/' + id, user, httpOptions);
  }


}
